import { gql } from '@apollo/client';

export const GET_PRODUCT_SALES = gql(/* GraphQL */ `
    query GetProductSales(
        $endDate: DateTime!
        $startDate: DateTime!
        $productId: String!
    ) {
        getProductSales(
            endDate: $endDate
            startDate: $startDate
            productId: $productId
        ) {
            id
            date
            totalQuantity
            totalValue
        }
    }
`);

export const GET_SCOPED_PRODUCT_SALES = gql(/* GraphQL */ `
    query GetScopedProductSales(
        $endDate: DateTime!
        $startDate: DateTime!
        $productId: String!
        $scope: ProductSalesScopeInput
    ) {
        getScopedProductSales(
            endDate: $endDate
            startDate: $startDate
            productId: $productId
            scope: $scope
        ) {
            sales {
                id
                date
                totalQuantity
                totalValue
            }
            isWarming
            storeCount
            currencies
        }
    }
`);

export default GET_PRODUCT_SALES;
